module.exports = __webpack_public_path__ + "assets/4ecb92e9fc40dc2fda297f0bde9ae000.png";